import { render } from "./FacilityName.vue?vue&type=template&id=399d2822"
import script from "./FacilityName.vue?vue&type=script&lang=js"
export * from "./FacilityName.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__